import { type ReactNode } from 'react';
import markerMapPlaceholder from '../../../../../assets/images/markerMapPlaceholder.png';
import {
  getContainerCss, markerMapPlaceholderStyle,
} from './tinyMapPlaceholder.styles';

export const TinyMapPlaceholderSize = {
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
} as const;

export enum TinyMapPlaceholderShape {
  Circle = 'Circle',
  Rectangle = 'Rectangle',
}

export type TinyMapPlaceholderSize = typeof TinyMapPlaceholderSize[keyof typeof TinyMapPlaceholderSize];

export type TinyMapPlaceholderComponentProps = {
  children?: ReactNode;
  className?: string;
  shape?: TinyMapPlaceholderShape;
  size?: TinyMapPlaceholderSize;
};

export const TinyMapPlaceholderComponent = (props: TinyMapPlaceholderComponentProps) => {
  const { className, size = 'Medium', children } = props;
  return (
    <div
      className={className}
      css={getContainerCss(size)}
    >
      <img
        alt="Marker map placeholder"
        css={markerMapPlaceholderStyle(props.shape)}
        src={markerMapPlaceholder}
      />
      {children}
    </div>
  );
};
